<template>
  <main>

    <section
      class="d-flex justify-content-between mx-5 my-5 cta-container w-75 mx-auto"
    >
      <button
        class="edit-button cta-section"
        @click="$emit('open', 'landingpage-ctas')"
        v-if="editable"
      >
        Edit
      </button>
      <landingpage-call-to-action
        :key="index + cta.ctaText"
        v-for="(cta, index) in callToActions"
        :ctaUrl="cta.ctaUrl"
        :ctaText="cta.ctaText"
        :bodyHtml="cta.bodyHtml"
        :css="landingpageCss"
      />
    </section>
    <section class="d-flex justify-content-between mx-auto mb-5 w-75">
      <landingpage-biobank-spotlight
        :headerText="biobankSpotlight.header"
        :biobankName="biobankSpotlight.biobankName"
        :biobankId="biobankSpotlight.biobankId"
        :bodyHtml="biobankSpotlight.bodyHtml"
        :buttonText="biobankSpotlight.buttonText"
        :css="landingpageCss"
      />
      <button
        class="edit-button biobank-spotlight-section"
        @click="$emit('open', 'landingpage-biobank-spotlight')"
        v-if="editable"
      >
        Edit
      </button>
      <landingpage-collection-spotlight
        :headerText="collectionSpotlight.header"
        :collections="collectionSpotlight.collections"
        :css="landingpageCss"
      />
      <button
        class="edit-button collection-spotlight-section"
        @click="$emit('open', 'landingpage-collection-spotlight')"
        v-if="editable"
      >
        Edit
      </button>
    </section>
  </main>
</template>

<script setup lang="ts">
import LandingpageBiobankSpotlight from "../components/landingpage-components/LandingpageBiobankSpotlight.vue";
import LandingpageCallToAction from "../components/landingpage-components/LandingpageCallToAction.vue";
import LandingpageCollectionSpotlight from "../components/landingpage-components/LandingpageCollectionSpotlight.vue";
import { useSettingsStore } from "../stores/settingsStore";
import ImageCard from "../components/ImageCard.vue";
import Button from "../components/Button.vue";
import { computed } from "vue";
import router from "../router";

const settingsStore = useSettingsStore();

withDefaults(
  defineProps<{
    editable: boolean;
  }>(),
  {
    editable: false,
  }
);

interface ILandingpageConfig {
  headerText?: string;
  page_biobank_spotlight?: {
    header?: string;
    biobankName?: string;
    biobankId?: string;
    bodyHtml?: string;
    buttonText?: string;
  };
  page_collection_spotlight?: any;
  page_call_to_actions?: any;
  css?: any;
}

const landingpage = computed(() =>
  settingsStore.configurationFetched
    ? (settingsStore.config.landingpage as ILandingpageConfig)
    : (settingsStore.config as ILandingpageConfig)
);

const biobankSpotlight = computed(
  () => landingpage.value.page_biobank_spotlight || {}
);
const collectionSpotlight = computed(
  () => landingpage.value.page_collection_spotlight
);
const callToActions = computed(() => landingpage.value.page_call_to_actions);
const landingpageCss = computed(() => landingpage.value.css);

const headerText = computed(
  () =>
    landingpage.value.headerText ??
    "Search the EUCAIM Catalogue by category"
);
</script>

<style scoped>
section {
  position: relative;
}

.edit-button {
  position: absolute;
  width: 3rem;
  top: 5%;
  z-index: 1000;
}

.header-section {
  right: 14%;
}

.cta-section {
  right: 2%;
}
.biobank-spotlight-section {
  top: 2%;
  right: 52%;
}

.collection-spotlight-section {
  top: 2%;
  right: 2%;
}

.cards-section-other {
  color: #003675;
}
</style>
